//import '../assets/icons/logo-no-background.png';
import '../css/normalize.css';
import '../css/style.min.css';
import soundToggler from './soundToggler.js';
import modalGame from './modal-game.js';
import birdsData from './birds.js';
import birdsDataEn from './birdsEn.js';
import game from './game.js';
import player from './player.js';
import playerDescr from './player-descr.js';
import swichLang from './swich-lang.js';

window.addEventListener('DOMContentLoaded', () => {

  let audioMain = new Audio('../src/assets/sound/main.mp3');
  audioMain.loop = true; 
  const audio = document.getElementById('audio');
  const audioDescr = document.getElementById('audio-descr');
  
  let namesArray = [];
  let namesArrayEn = [];
  
  swichLang(namesArray, namesArrayEn);
  soundToggler(audioMain);
  modalGame(audioMain);
  game(birdsData, audioDescr, audio, birdsDataEn, namesArray, namesArrayEn);
  player(audio);
  playerDescr(audioDescr);


});